import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import SchemaParser from '../../services/SchemaParser';
import styles from './delegateCard.module.scss';
import { store } from '../../../models';

const DelegateCard = React.memo(({ id, profileId, topContent, expandedContent, avatar, currentUser, history, isBreezePatient, breezeUser }) => {
  const createDelegateProfile = () => {
    store.dispatch.modal.toggleOpen('delegateSignUpModal');
  }
  const clickHandler = (representedUserId, breezeUser, currentUser, isBreezePatient) => {
    if(currentUser){
      if(isBreezePatient){
        sessionStorage.removeItem('CC-Breeze-Web-representedUserId');
        representedUserId && sessionStorage.setItem('CC-Breeze-Web-representedUserId', representedUserId);
        sessionStorage.removeItem('isBreezePatient');
        sessionStorage.setItem('isBreezePatient', breezeUser)
        history.push('/dashboard');
        window.location.reload()
      }else{
        createDelegateProfile();
      }
    }else{
      sessionStorage.removeItem('CC-Breeze-Web-representedUserId');
      representedUserId && sessionStorage.setItem('CC-Breeze-Web-representedUserId', representedUserId);
      sessionStorage.removeItem('isBreezePatient');
      sessionStorage.setItem('isBreezePatient', breezeUser)
      history.push('/dashboard');
      window.location.reload()
    }  
  };
  return (
    //eslint-disable-next-line
    <div id={id} className={classNames(currentUser ? isBreezePatient  ? styles.delegateCardWrapper: styles.delegateCardWrapperDisable : styles.delegateCardWrapper, { [styles.hasNoPractices]: !expandedContent[0].components.length })}>
      {/* eslint-disable-next-line */}
      <div onClick={()=>clickHandler(profileId, breezeUser, currentUser, isBreezePatient)}role="presentation" className={classNames(styles.delegateCardTop, { [styles.currentUserTop]: currentUser })}>
        <SchemaParser schema={topContent} />
      </div>
      <div className={classNames(styles.delegateAvatar)}>
        <SchemaParser schema={avatar} />
      </div>
      <div className={classNames(styles.expandedContent)}>
        <SchemaParser schema={expandedContent} />
      </div>
    </div>
  );
});

const mapStateToProps = ({ delegateCard }) => ({ delegateCard });

export default connect(mapStateToProps)(DelegateCard);
